import { MutateOptions, useMutation } from '@tanstack/react-query';
import { TGenericError } from 'types/TGenericError';
import { downloadFile } from 'utils/downloadFile';

export const useInvoiceFile = (
  options: MutateOptions<unknown, TGenericError, string, unknown> = {}
) => {
  return useMutation<void, TGenericError, string, unknown>({
    ...options,
    mutationFn: async (downloadId: string) => downloadFile(`/downloads/${downloadId}`)
  });
};
